import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ApiService from '@/services/api.service'
import store from '@/store'
Vue.use(VueI18n)

function loadLocaleMessages () {
  const messages = {}
  ApiService.get('/translation/get-list', {}).then(response => {
    for(let i in response) {
      messages[i] = response[i]
    }
    store.dispatch('language/isLoaded')
  })
  return messages
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
  missing: (locale, key) => {
    //store.dispatch('language/setMissingTranslation', locale, key)
    if (store.getters['language/isLoaded'] && store.getters['auth/isLoggedIn']) {
      ApiService.create('/missing-translations', {
        'message': key,
      })   
    }
  }
})